var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderDynamicGeneratedChild.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderDynamicGeneratedChild = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.1",
    width: "24",
    height: "24",
    rx: "4",
    fill: "#2235AA"
  }), /*#__PURE__*/_jsx("path", {
    opacity: "0.5",
    d: "M10.4425 6.4425C10.1575 6.1575 9.775 6 9.3775 6H5.5C4.675 6 4.0075 6.675 4.0075 7.5L4 16.5C4 17.325 4.675 18 5.5 18H18.5C19.325 18 20 17.325 20 16.5V9C20 8.175 19.325 7.5 18.5 7.5H11.5L10.4425 6.4425Z",
    fill: color
  }), /*#__PURE__*/_jsx("g", {
    opacity: "0.8",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.12 11.7498L12.0001 10.101L9.87842 11.7512L11.9997 13.4005L14.12 11.7498ZM11.7443 16.581C11.7509 16.5861 11.7576 16.591 11.7643 16.5956C11.9072 16.6938 12.0964 16.6931 12.2387 16.5937C12.2445 16.5897 12.2503 16.5854 12.2559 16.581L15.3274 14.1921C15.5417 14.0254 15.5415 13.7007 15.3272 13.5338C15.2822 13.4987 15.2317 13.4741 15.179 13.4599C15.0558 13.4269 14.9206 13.4512 14.8152 13.5331C14.8153 13.533 14.8151 13.5331 14.8152 13.5331L12.2517 15.5269C12.2478 15.5299 12.2438 15.5329 12.2398 15.5358C12.1998 15.5647 12.1558 15.5857 12.1102 15.5987C12.0376 15.6194 11.9607 15.6199 11.8879 15.6004C11.839 15.5873 11.792 15.5652 11.7495 15.5339C11.7464 15.5316 11.7432 15.5293 11.7402 15.5269L9.17962 13.5361C9.07554 13.4552 8.94242 13.4305 8.82071 13.4622C8.76742 13.4761 8.7163 13.5007 8.67074 13.5361C8.45741 13.7021 8.45741 14.0245 8.67074 14.1904L11.7443 16.581ZM15.0668 12.28L15.3256 12.0795C15.5408 11.9129 15.5411 11.5882 15.3263 11.4212L12.2559 9.03308C12.1055 8.91606 11.8948 8.91606 11.7443 9.03308L8.67263 11.4222C8.45827 11.5889 8.45813 11.9128 8.67235 12.0798L8.9293 12.28L11.7442 14.4685C11.7886 14.503 11.8382 14.5273 11.8899 14.5414C11.9599 14.5606 12.0337 14.5611 12.1039 14.5431C12.158 14.5292 12.2098 14.5042 12.2559 14.4683L15.0668 12.28Z",
      fill: "white"
    })
  })]
});